/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Partner role on the BR in a beneficial-owner capacity
 * @export
 * @interface BeneficialOwnerPartnerRole
 */
export interface BeneficialOwnerPartnerRole {
    /**
     * 
     * @type {string}
     * @memberof BeneficialOwnerPartnerRole
     */
    partnerUid?: string;
    /**
     * Partner identifier on the role when present (typically the PCM partner number, e.g. n_…)
     * @type {string}
     * @memberof BeneficialOwnerPartnerRole
     */
    partnerId?: string | null;
    /**
     * Partner-to-BR role code (e.g. BENEFICIAL_OWNER, BENEFICIAL_OWNER_THIRD_PARTY, BENEFICIARY)
     * @type {string}
     * @memberof BeneficialOwnerPartnerRole
     */
    roleType?: string;
    /**
     * Partner-to-BR role label
     * @type {string}
     * @memberof BeneficialOwnerPartnerRole
     */
    partnerToBrRole?: string | null;
    /**
     * Partner display name from partner data management
     * @type {string}
     * @memberof BeneficialOwnerPartnerRole
     */
    partnerName?: string | null;
    /**
     * INDIVIDUAL_PARTNER or LEGAL_ENTITY_PARTNER when resolved from PCM
     * @type {string}
     * @memberof BeneficialOwnerPartnerRole
     */
    partnerStructureType?: string | null;
    /**
     * Whether the partner is imported in PCM, when known
     * @type {boolean}
     * @memberof BeneficialOwnerPartnerRole
     */
    partnerImported?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof BeneficialOwnerPartnerRole
     */
    validFrom?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof BeneficialOwnerPartnerRole
     */
    validTo?: Date | null;
    /**
     * False when the role has ended (validTo is strictly before the current server time). True when validTo is null (open-ended) or validTo is not strictly before the current time.
     * 
     * @type {boolean}
     * @memberof BeneficialOwnerPartnerRole
     */
    valid?: boolean;
}

/**
 * Check if a given object implements the BeneficialOwnerPartnerRole interface.
 */
export function instanceOfBeneficialOwnerPartnerRole(value: object): value is BeneficialOwnerPartnerRole {
    return true;
}

export function BeneficialOwnerPartnerRoleFromJSON(json: any): BeneficialOwnerPartnerRole {
    return BeneficialOwnerPartnerRoleFromJSONTyped(json, false);
}

export function BeneficialOwnerPartnerRoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): BeneficialOwnerPartnerRole {
    if (json == null) {
        return json;
    }
    return {
        
        'partnerUid': json['partnerUid'] == null ? undefined : json['partnerUid'],
        'partnerId': json['partnerId'] == null ? undefined : json['partnerId'],
        'roleType': json['roleType'] == null ? undefined : json['roleType'],
        'partnerToBrRole': json['partnerToBrRole'] == null ? undefined : json['partnerToBrRole'],
        'partnerName': json['partnerName'] == null ? undefined : json['partnerName'],
        'partnerStructureType': json['partnerStructureType'] == null ? undefined : json['partnerStructureType'],
        'partnerImported': json['partnerImported'] == null ? undefined : json['partnerImported'],
        'validFrom': json['validFrom'] == null ? undefined : (new Date(json['validFrom'])),
        'validTo': json['validTo'] == null ? undefined : (new Date(json['validTo'])),
        'valid': json['valid'] == null ? undefined : json['valid'],
    };
}

export function BeneficialOwnerPartnerRoleToJSON(json: any): BeneficialOwnerPartnerRole {
    return BeneficialOwnerPartnerRoleToJSONTyped(json, false);
}

export function BeneficialOwnerPartnerRoleToJSONTyped(value?: BeneficialOwnerPartnerRole | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'partnerUid': value['partnerUid'],
        'partnerId': value['partnerId'],
        'roleType': value['roleType'],
        'partnerToBrRole': value['partnerToBrRole'],
        'partnerName': value['partnerName'],
        'partnerStructureType': value['partnerStructureType'],
        'partnerImported': value['partnerImported'],
        'validFrom': value['validFrom'] == null ? value['validFrom'] : value['validFrom'].toISOString(),
        'validTo': value['validTo'] == null ? value['validTo'] : value['validTo'].toISOString(),
        'valid': value['valid'],
    };
}

